import { InputMask } from 'imask';
import { useCallback, useEffect, useRef } from 'react';
export function useMask({
  value,
  onValueChange,
  options
}) {
  const inputRef = useRef(null);
  const maskRef = useRef();
  const createHandleComplete = useCallback(mask => {
    return () => {
      onValueChange?.(mask.typedValue);
    };
  }, [onValueChange]);
  useEffect(() => {
    if (!inputRef.current) {
      return;
    }
    const mask = new InputMask(inputRef.current, options);
    const handleComplete = createHandleComplete(mask);
    mask.on('accept', handleComplete);
    maskRef.current = mask;
    return () => {
      mask.off('accept', handleComplete);
      mask.destroy();
    };
  }, [createHandleComplete, options]);
  useEffect(() => {
    if (!maskRef.current || typeof value === 'undefined') {
      return;
    }
    maskRef.current.typedValue = value;
  }, [value]);
  return inputRef;
}